<HiddenFromSSR>
  <footer>
    {@html "<p> <small> <a title=\"Rauchzeichentelefon\" href=\"https://smoke.tel/\" class=\"btn-sm btn-link\" style=\"white-space: nowrap;\">☎️ Rauchzeichentelefon</a> | <a href=\"https://startforum.de/\" title=\"Startforum Social Networks\" class=\"btn-sm btn-link\">☕ Startforum Social Networks</a> <br />Mastodon@Startforum is based on <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/nolanlawson/pinafore\">Pinafore</a>, made by <a rel=\"noopener\" target=\"_blank\" href=\"https://nolanlawson.com\">Nolan Lawson</a> <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/nolanlawson/pinafore/blob/master/LICENSE\">&copy; License</a>. </small> </p> <p> <a href=\"/settings/about#privacy-policy\" rel=\"prefetch\">Privacy policy</a> | <a href=\"https://startforum.de/p/imprint\">Imprint</a> </p>"}
  </footer>
</HiddenFromSSR>
<script>
  import HiddenFromSSR from './HiddenFromSSR.html'

  export default {
    components: {
      HiddenFromSSR
    }
  }
</script>
